import './App.css';
import { Layout } from 'antd';
import 'antd/dist/antd.css';
import { Navbar, Sidebar } from './services'
import { Outlet } from 'react-router-dom';
import { useState } from 'react';

function App() {
  const { Content } = Layout;
  const [open, setOpen] = useState(false)
  return (
    <div className="App">
      <Layout>
        <Sidebar open={open} close={() => setOpen(false)} />
        <Layout >
          <Navbar open={open} setOpen={() => setOpen(true)} />
          <Content style={{ background: "var(--color-white)" }}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default App;
